export const words = [
  'kurwa',
  'kurwo',
  'kurwie',
  'bladź',
  'kurwom',
  'kurwami',
  'kurwą',
  'kurwy',
  'kurewka',
  'kurewski',
  'kurwiszcze',
  'lachociąg',
  'matkojebca',
  'kurwisko',
  'kurwiszon',
  'skurwiony',
  'skurwiona',
  'zkurwiony',
  'zkurwiona',
  'pizdy',
  'pizda',
  'pizde',
  'pizdę',
  'dziwka',
  'dziwki',
  'fiut',
  'pizd',
  'debil',
  'debilu',
  'debile',
  'idiota',
  'idioto',
  'kutas',
  'kutafon',
  'idiocie',
  'idioci',
  'ciota',
  'cioto',
  'cipa',
  'cipą',
  'cipę',
  'cipką',
  'cipok',
  'cipie',
  'cipje',
  'cwel',
  'cwelić',
  'cwelic',
  'cwele',
  'cwelu',
  'pierdole',
  'pierdolenie',
  'pierdolic',
  'pierdolić',
  'pierdolony',
  'pierdolona',
  'pierdolone',
  'pojeb',
  'pojebany',
  'pojebana',
  'popierdole',
  'popierdolony',
  'popierdolona',
  'popierdolone',
  'niedojebany',
  'niedojebana',
  'niedojebane',
  'niedojebani',
  'chuju',
  'chuj',
  'chuja',
  'chujem',
  'chujowi',
  'chujów',
  'chuja',
  'chujow',
  'chujowy',
  'chujowa',
  'chujowe',
  'chujowi',
  'jebac',
  'jebać',
  'jebak',
  'jebadło',
  'jebadlo',
  'jebany',
  'jebana',
  'jebane',
  'jebani',
  'zjeb',
  'zjebie',
  'polecam tego typera',
  'polecam typera',
  'telegram',
  'telegramu',
  'telegramie',
  'telegrama',
  'wbijajcie do grupy',
  'wbijajcie do jego grupy',
  'typeriapl',
  'pedał',
  'pedal',
  'pedałki',
  'pedałku',
  'pedałkowi',
  'pedalce',
  'pedałowanie',
  'pedalku',
  'pedalem',
  'penis',
  'pedałem',
  'pedalami',
  'pedałami',
  'pedale',
  'wyjebać',
  'wyjabac',
  'wyjeban',
  'odjebać',
  'obsrany',
  'obsrać',
  'obsrac',
  'pedały',
  'gej',
  'geje',
  'geju',
  'gejom',
  'gejami',
  'czarnuch',
  'nigger',
  'smoluch',
  'smoluh',
  'fuck',
  'shit',
  'asshole',
  'cock',
  'cunt',
  'faggot',
];

const leetMap = new Map();
leetMap.set('@', 'a');
leetMap.set('4', 'a');
leetMap.set('3', 'e');
leetMap.set('!', 'i');
leetMap.set('0', 'o');
leetMap.set('1', 'i');
leetMap.set('|', 'i');
leetMap.set(']', 'j');
leetMap.set('$', 's');
leetMap.set('7', 't');
leetMap.set('2', 'z');

const formatPhrase = (phrase) => /(faggot|nigger)/gi.test(phrase) ? phrase.toLocaleLowerCase() : phrase
                  .trim()
                  .toLocaleLowerCase()
                  .replace(/(.)\1+/g, '$1') // remove consecutive duplicate characters
                  .split("")
                  .map(char => leetMap.has(char) 
                                      ? leetMap.get(char) 
                                      : char) // translate leetspeak
                  .join("") 
                  .replace(/[$&+,:;=?@#|'<>.^*()%!-_]/g, "") // remove special characters

const checkPhrase = (formattedPhrase) => 
            words.some(word => formattedPhrase.includes(word));


export const isPhraseOffensive = (phrase) => checkPhrase(formatPhrase(phrase));
            



